module.exports = __webpack_public_path__ + "static/media/meta.a8044507.png";